import React, { type FC } from 'react';
import { isJsmVirtualAgentOnPortalEAPAvailable } from 'feature-flags';
import Spinner from '@atlaskit/spinner';
import { Message } from '@atlassian/help-center-conversation';
import type { AgentMessage as AgentMessageType } from '../../../../common/types';
import { Appendices } from '../../../../common/ui/appendices';
import { useFieldFromLastMessage } from '../../../../controllers/conversation-store';
import { useRequestTypeFields } from '../../../../services/request-type-fields-service';
import { Content } from './content';

export const AgentMessage: FC<{ message: AgentMessageType['message']; isLastMessage: boolean }> = ({
    message,
    isLastMessage,
}) => {
    const [{ loading: isFieldsLoading }] = useRequestTypeFields();
    const jiraField = useFieldFromLastMessage();
    const isLoading = isFieldsLoading && isLastMessage && jiraField;

    return isLoading ? (
        <Spinner size="medium" />
    ) : (
        <Message
            content={<Content message={message} />}
            position="left"
            borderColor={isJsmVirtualAgentOnPortalEAPAvailable() ? undefined : 'grey'}
            backgroundColor={isJsmVirtualAgentOnPortalEAPAvailable() ? 'grey' : undefined}
            fullWidth
            actions={
                isJsmVirtualAgentOnPortalEAPAvailable() && isLastMessage ? (
                    <Appendices appendices={message.appendices} />
                ) : undefined
            }
        />
    );
};
